import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  noData: {
    padding: 32,
  },
  rowIsAsignee: {
    backgroundColor: theme.hv.palette.semantic.sema7,
    "& > $cellIsAsignee": {
      backgroundColor: theme.hv.palette.semantic.sema7,
    },
  },
  cellIsAsignee: {
    color: theme.hv.palette.base.base2,
    "& > div": {
      color: theme.hv.palette.base.base2,
    },
  },
}));

export default useStyles;
